export default "__VITE_ASSET__BqCdemyU__"